export const GET_MY_DOCUMENT_REQUEST = 'GET_MY_DOCUMENT_REQUEST';
export const GET_MY_DOCUMENT_SUCCESS = 'GET_MY_DOCUMENT_SUCCESS';
export const GET_MY_DOCUMENT_FAIL = 'GET_MY_DOCUMENT_FAIL';
